/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DataService as ɵa} from './lib/dataservice.service';
export {SocketdataService as ɵc} from './lib/socketdata.service';
export {XldataService as ɵb} from './lib/xldata.service';